import React           from 'react';
import { Translate }   from 'react-localize-redux';
import styled, { css } from 'styled-components';
import Link            from '../../components/link';
import ImgWorld        from './images/world.png';
import ImgBanner       from './images/btn_compass.png';
import Section         from './section';
import titleImg        from './images/title/World.png';

const ImageW = styled.img` width: 100%; `;
const ImageB = styled.img`
  margin-left: 24vw;
  width: 50vw;
`;

/**
 * Worldのセクション
 */
const World = () => {

  return (
    <>
      <Section imgSrc={titleImg} />
      <ImageW src={ImgWorld}  />
      <a href="https://app.nhn-playart.com/compass/index.nhn">
        <ImageB src={ImgBanner} />
      </a>
    </>
  );
};

export default World;
